import { Controller, FieldValues, Path, PathValue } from 'react-hook-form';
import './style.scss';
import { SearchOutlined } from '@mui/icons-material';
import { AutoComplete } from '@shape-ds/components';
import { AutoCompleteProps } from './FormInputProps';

export const FormAutocomplete = <T extends FieldValues>({
  name,
  control,
  label,
  options,
  defaultValue,
  isRequired,
  placeHolder,
  ...props
}: AutoCompleteProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: isRequired ? 'This field is required' : false }}
      defaultValue={defaultValue as PathValue<T, Path<T>>}
      render={({ field: { onChange, value } }) => {
        const selectedOption = options.find((option) => option.id === value);
        const defaultOption = options.find((option) => option.id === defaultValue);

        return (
          <div data-testid={name}>
            <label htmlFor={name}>{label}</label>
            <AutoComplete
              className="form-input"
              data-testid={name}
              onSelect={(selectedItem) => onChange(selectedItem?.id)}
              placeHolder={placeHolder ?? label}
              options={options}
              icon={!defaultValue && <SearchOutlined />}
              iconPosition="end"
              defaultValue={defaultOption}
              selectedValues={selectedOption || defaultOption}
              {...props}
            />
          </div>
        );
      }}
    />
  );
};
